import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const Container = styled.div`
  padding: ${rem(12)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

function RoomBreakdownLoadingSkeleton() {
  return (
    <Container>
      <Group direction="vertical" gap={8}>
        <LoadingBox height={16} width={180} borderRadius="XS" />
        <Group direction="vertical" gap={4}>
          <LoadingBox height={14} width={140} borderRadius="XS" />
          <LoadingBox height={14} width={200} borderRadius="XS" />
        </Group>
      </Group>
    </Container>
  )
}

export default RoomBreakdownLoadingSkeleton
